import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const ApplicationDetailSkeleton: React.FC = () => (
  <div className="space-y-4">
    <div className="flex items-start gap-3">
      <Skeleton className="h-8 w-8" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-7 w-64" />
        <Skeleton className="h-4 w-48" />
      </div>
      <Skeleton className="h-8 w-28" />
      <Skeleton className="h-8 w-24" />
    </div>
    <div className="space-y-3 rounded-lg border p-6">
      <Skeleton className="h-5 w-24" />
      {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-4 w-full" />)}
    </div>
    <div className="space-y-2 rounded-lg border p-6">
      <Skeleton className="h-8 w-72" />
      {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-9 w-full" />)}
    </div>
  </div>
)
export default ApplicationDetailSkeleton
